import { QueryClient } from '@tanstack/react-query';

// Quando o canal de tempo real (SSE) está fora do ar, as telas voltam a consultar o servidor
// periodicamente, para a informação continuar confiável.
let realtimeConnected = false;
export function setRealtimeConnected(v) {
  realtimeConnected = v;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: () => (realtimeConnected ? false : 60_000),
      // Erros 4xx (permissão, não encontrado, validação) não melhoram com retentativa.
      retry: (count, err) => (err?.status >= 400 && err?.status < 500 ? false : count < 2),
    },
    mutations: { retry: false },
  },
});

/**
 * Zera o cache ao encerrar a sessão (logout ou exclusão de conta).
 *
 * Não use `queryClient.clear()`: ele remove as consultas sem avisar os observadores já
 * montados, que ficam presos ao objeto destruído — a tela congela no estado de logado e
 * `['me']` nunca é reconsultado. Definir `['me']` como null notifica a sessão (o guard leva
 * ao login) e as demais consultas saem do cache para o próximo usuário não ver dados antigos.
 */
export function resetSessionCache(qc) {
  qc.setQueryData(['me'], null);
  qc.removeQueries({ predicate: (q) => q.queryKey[0] !== 'me' });
}

// Entidade alterada (evento SSE) -> prefixos de consultas a atualizar.
export const ENTITY_KEYS = {
  tasks: ['tasks', 'dashboard', 'areas'],
  areas: ['areas', 'tasks'],
  shopping: ['shopping', 'dashboard', 'pantry'],
  pantry: ['pantry', 'dashboard', 'shopping', 'meals'],
  meals: ['meals', 'dashboard'],
  finance: ['finance', 'dashboard'],
  agenda: ['agenda', 'dashboard'],
  maintenance: ['maintenance', 'dashboard'],
  documents: ['documents', 'maintenance', 'finance'],
  inbox: ['inbox'],
  members: ['household'],
  household: ['household'],
};

export function invalidateEntity(householdId, entity) {
  if (entity === 'notifications') {
    queryClient.invalidateQueries({ queryKey: ['notifications'] });
    return;
  }
  if (entity === 'members' || entity === 'household') queryClient.invalidateQueries({ queryKey: ['me'] });
  for (const k of ENTITY_KEYS[entity] ?? [entity])
    queryClient.invalidateQueries({ queryKey: [householdId, k] });
}
